<template>
  <div>
    <div class="cp-edit">
      <div class="cp-menu">
        <p>Admission Profile</p>
        <ul class="tabs">
          <li><a href="javascript:;" class="tablinks" id="defaultOpen" @click="openCity($event, 'basicInfo')">Basic Info</a></li>
          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'info')">Highlights</a></li>
          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'course')">Courses & Fee</a></li>
          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'scholarship')">Scholarships</a></li>
          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'placement')">Placements</a></li>
          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'cutOff')">CutOff</a></li>
          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'faculty')">Faculty</a></li>
          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'infra')">Infrastructure</a></li>
<!--          <li><a href="javascript:;" class="tablinks" @click="openCity($event, 'gallery')">Gallery</a></li>-->
        </ul>
      </div>
      <div class="tab-container">
        <div class="tabcontent" id="basicInfo">

           <div class="row">
            <div class="col-md-12">
            <form action="" id="basicInfoForm" @submit.prevent="update()">
              <div class="dash-inner-box">
                <div class="row">
                  <div class="col-md-12">
                      <div class="dashboard-heading">
                        <h1>Change Account Setting</h1>
                      </div>
                  </div>
                <!--                                            <div class="col-md-12">-->
                <!--                                                <div class="epp">-->
                <!--                                                    <div class="edit-profile-pic">-->
                <!--                                                        <img v-bind:src="image" v-if="image">-->
                <!--                                                        <img src="/images/user_avatar.png" v-else>-->
                <!--                                                        <label for="cp-edit"><i class="fas fa-pencil-alt"></i></label>-->
                <!--                                                    </div>-->
                <!--                                                    <div class="pic-details">-->
                <!--                                                        <input type="file" id="cp-edit" class="file"-->
                <!--                                                               @change="onPhotoUploaded">-->
                <!--                                                    </div>-->
                <!--                                                </div>-->
                <!--                                            </div>-->
                  <div class="p10-20">
                    <div class="col-md-6 col-sm-6">
                      <div class="form-group">
                        <label class="ep-input-label" for="college_name">College Name</label>
                          <input type="text" class="form-control dash-input" id="college_name"
                                 placeholder="College Name"
                                 name="college_name" v-model="college_name" disabled>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="ep-input-label" for="college_affi">Affiliated To</label>
                          <input type="text" class="form-control dash-input" id="college_affi"
                                 placeholder="University Name"
                                 name="college_affi" v-model="college_affiliated_to">
                          <div id="university-er" v-html="affiliated_to_error"
                               class="form-text text-muted"></div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="job-des" class="ep-input-label">About College</label>
                          <textarea id="job-des" class="form-control dash-input"
                                    v-model="college_description"></textarea>
                          <div id="job-er" class="form-text text-muted"></div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="ep-input-label" for="college_web">College Website</label>
                          <input type="text" class="form-control dash-input" id="college_web"
                                 placeholder="Website"
                                 name="college_web" v-model="college_website">
                          <div id="college-er" v-html="website_error"
                               class="form-text text-muted"></div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="ep-input-label" for="college_loc">Location</label>
                          <input type="text" class="form-control dash-input" id="college_loc"
                                 placeholder="Location"
                                 name="college_loc" v-model="college_city">
                          <div id="location-er" v-html="city_error"
                               class="form-text text-muted"></div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label class="ep-input-label" for="college_number">Email</label>
                          <input type="text" class="form-control dash-input" id="email"
                                 placeholder="Email" name="college_email"
                                 v-model="college_email" disabled>
                      </div>
                    </div>
                    <div class="col-md-6">
                  <div class="form-group">
                    <label class="ep-input-label" for="college_number">Phone
                      Number</label>
                      <input type="text" class="form-control dash-input"
                             id="college_number" placeholder="Phone Number"
                             name="college_number" v-model="college_phone" disabled>
                  </div>
                </div>
                  </div>

                <div class="col-md-12">
                  <StreamModal></StreamModal>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="mt30 dashboard-heading">
                        <h1>Streams</h1>
                      </div>
                    </div>
                  </div>
                  <div class="all-courses p10-20">
                    <div class="row">
                      <div class="col-md-3">
                        <div class="course-box">
                          <div class="course-details">
                            <div class="course-name">
                              <button type="button"  @click="streamModal(true)">
                                <i class="fas fa-plus"></i>
                              </button>
                            </div>
                            <div class="course-duration">Add New</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-3" v-for="s in streams">
                        <div class="course-box">
                          <div class="course-details">
                            <div class="course-name">{{s.stream}}</div>
                            <!--                                                        <div class="course-duration">3 Courses</div>-->
                          </div>
                          <!--                                                      <div class="course-edit">-->
                          <!--                                                        <button type="button">-->
                          <!--                                                          <i class="fas fa-pen"></i></button>-->
                          <!--                                                      </div>-->
                          <div class="course-remove">
                            <button type="button" @click="removeStream($event)"
                                v-bind:data-key="s.assigned_college_enc_id">
                              <i class="fas fa-times"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="align-center">
                  <div class="col-md-12">
                    <div class="form-group text-center">
                      <button type="submit" class="cpe-button add-course">Update</button>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </form>
          </div>
        </div>

          <div class="row">
            <div class="col-md-12 margin-top-20">
              <div class="dash-inner-box">
                <div class="dashboard-heading">
                  <div class="row">
                    <div class="col-md-6">
                      <h1>Change Account Setting</h1>
                    </div>
                  </div>
                </div>
                <div class="college-profile-form">
                  <form id="changePassForm" @submit.prevent="changePassword()">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="ep-input-label" for="old-password">Old
                            Password</label>
                          <input type="password" class="form-control dash-input field-req"
                                 id="old-password" placeholder="Old Password"
                                 name="old_password">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="ep-input-label" for="new-password">New
                            Password</label>
                          <input type="password" class="form-control dash-input field-req"
                                 id="new-password" placeholder="New Password"
                                 name="new_password">
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="ep-input-label" for="confirm-password">Confirm
                            Password</label>
                          <input type="password" class="form-control dash-input field-req"
                                 id="confirm-password" placeholder="Confirm New Password"
                                 name="repeat_new_password">
                        </div>
                      </div>
                      <div class="col-md-12 text-center">
                        <div class="form-group">
                          <button type="submit" class="cpe-button add-course">Change Password</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="tabcontent" id="info">
          <Highlights></Highlights>
        </div>
        <div class="tabcontent" id="course">
          <courses-and-admission ref="course&admission"></courses-and-admission>
        </div>
        <div class="tabcontent" id="scholarship">
          <scholarship ref="scholar"></scholarship>
        </div>
        <div class="tabcontent" id="placement">
          <placements ref="placement"></placements>
        </div>
        <div class="tabcontent" id="faculty">
          <faculty ref="facultyComp"></faculty>
        </div>
        <div class="tabcontent" id="cutOff">
          <cutoff ref="cutoffComp"></cutoff>
        </div>
        <div class="tabcontent" id="infra">
            <infrastructure></infrastructure>
        </div>
<!--        <div class="tabcontent" id="gallery">-->
<!--          <gallery></gallery>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";
import Cutoff from "../../components/collegeProfile/Cutoff";
import Scholarship from "../../components/collegeProfile/Scholarship";
import Infrastructure from "../../components/collegeProfile/Infrastructure";
import Faculty from "../../components/collegeProfile/Faculty";
import CoursesAndAdmission from "../../components/collegeProfile/CoursesAndAdmission";
import Placements from "../../components/collegeProfile/Placements";
import Gallery from "../../components/collegeProfile/Gallery";
import toastr from "../../../public/js/toastr";
import StreamModal from './../../components/StreamModal.vue'
import Highlights from "../../components/collegeProfile/Highlights";

export default {
  components: {
    Highlights,
    Gallery,
    Placements,
    CoursesAndAdmission,
    Faculty,
    Infrastructure,
    Scholarship,
    Cutoff,
    StreamModal
  },
  data() {
    return {
      elemIds: 0,
      url: this.$store.getters.getDomain,
      addmissionCourses: [],
      scholarships: [],
      notchLoading: null,
      streams: [],
      collegeDetails: [],
      college_name:'',
      website_error: '',
      affiliated_to_error: '',
      city_error: '',
      college_description: '',
      college_enc_id: '',
      college_phone: '',
      college_email: '',
      college_website: '',
      college_city: '',
      college_affiliated_to: '',
    }
  },
  mounted() {
    if (document.getElementById("defaultOpen")) {
      document.getElementById("defaultOpen").click();
    }

    this.getAdmissionCourses();
    this.getScholarships();
    this.fetchDetails();
  },
  created() {
    window.changeRacLogo = this.changeRacLogo.bind(this);

  },
  methods: {
    showError(parElem, inputElem, errorType) {
      let msg = errorType == 'number' ? 'Please enter number' : 'This Field Is Required';
      parElem.querySelector('.errorMsg').innerText = msg;
      parElem.querySelector('.errorMsg').style.display = 'block';
      inputElem.classList.add('hasError');
    },
    hideError(parElem, inputElem) {
      parElem.querySelector('.errorMsg').innerText = '';
      parElem.querySelector('.errorMsg').style.display = 'none';
      inputElem.classList.remove('hasError');
    },
    validateFiled(event, onCreate = null) {
      let inputElem;
      if (!onCreate) {
        inputElem = event.target;
      } else {
        inputElem = event;
      }
      let inputElemVal = inputElem.value;
      let inputElemType = inputElem.getAttribute('data-type');
      let inputElemName = inputElem.getAttribute('data-id');
      let parElem = inputElem.parentElement;
      let errorType;
      const num = /^[0-9]+$/;
      const floatNumber = /[\+]?([\-]?([0-9]{1,})?[\.]?[0-9]{1,})/;
      if (inputElemType == 'floatNum' && inputElemVal != '') {
        if (!inputElemVal.match(floatNumber)) {
          errorType = 'number';
          this.showError(parElem, inputElem, errorType)
          return false;
        } else {
          this.hideError(parElem, inputElem)
        }
      }
      if (inputElemType == 'number' && inputElemVal != '') {
        if (!inputElemVal.match(num)) {
          errorType = 'number';
          this.showError(parElem, inputElem, errorType)
          return false;
        } else {
          this.hideError(parElem, inputElem)
        }
      }
      if (inputElemType == 'isRequired' || inputElemName == 'reqAlso') {
        if (inputElemVal == '') {
          errorType = 'required';
          this.showError(parElem, inputElem, errorType);
          return false;
        } else {
          this.hideError(parElem, inputElem)
        }
      }
    },
    fetchDetails(){
      let t = this;
      axios.post(`${this.url}api/v2/college-profile/fetch-details`, {}, {headers:requestHeaders()}).then(
        function(response){
          if(response['data']['response']['status'] == 200){
            t.collegeDetails = response['data']['response']['detail'];
            console.log(t.collegeDetails);
            var detail = response['data']['response']['detail'];
            t.college_name = t.htmlDecoder(detail['name']);
            t.college_website = detail['website'];
            t.college_description = detail['description'];
            t.college_phone = detail['phone'];
            t.college_email = detail['email'];
            t.college_enc_id = detail['organization_enc_id'];
            // t.coursesList = response['data']['response']['courses'];
            // t.$store.dispatch("setCourses", t.coursesList);
            // t.image = detail['logo'];
            t.college_city = detail['city'];
            t.college_affiliated_to = detail['affiliated_to'];
            t.streams = response['data']['response']['streams'];
          }

        }
      )
    },
    createDataObject(elem) {
      let saveField = elem.querySelectorAll('.saveField');
      let data = new FormData();
      for (let i = 0; i < saveField.length; i++) {
        let fieldReq = saveField[i].getAttribute('data-id');
        let fieldDataType = saveField[i].getAttribute('data-type');
        let self = this;
        if (fieldReq == 'reqAlso' || fieldDataType == 'isRequired') {
          let onCreate = true;
          self.validateFiled(saveField[i], onCreate);
        }
        let fieldType = saveField[i].getAttribute('type');
        if (fieldType == 'file') {
          data.append(saveField[i].getAttribute('name'), self.$refs.facultyComp.cropedImg);
        } else {
          data.set(saveField[i].getAttribute('name'), saveField[i].value)
        }
      }
      return data
    },
    emptyFormFields(elem) {
      let saveField = elem.querySelectorAll('.saveField');
      for (let i = 0; i < saveField.length; i++) {
        saveField[i].value = "";
      }
    },
    cancelUpdate(){
      let self = this;
      let toEmptyElem = event.currentTarget.getAttribute('data-id');
      switch (toEmptyElem){
        case 'faculty':
          self.$refs.facultyComp.eFaculty = '';
          break;
        case 'scholarship':
          self.$refs.scholar.eScholarship = '';
          break;
        case 'cutoff':
          self.$refs.cutoffComp.eCutoff = '';
          break;
      }

    },
    getScholarships() {
      let t = this;
      axios.post(`${this.url}api/v2/college-profile/get-scholarships`, {}, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              t.scholarships = response['data']['response']['scholarships'];
            } else {

            }
          }
      )
    },
    getAdmissionCourses() {
      let t = this;
      axios.post(`${this.url}api/v2/college-profile/get-admission-courses`, {}, {headers: requestHeaders()}).then(
          function (response) {
            if (response['data']['response']['status'] == 200) {
              t.addmissionCourses = response['data']['response']['courses'];
            }
          }
      )
    },
    recTemp(inputID) {
      var t = this;
      let recTemplate = `<div class="col-md-3 border-right"><div class="topRecLogo"><span class="logoshow"><p>Add <br>Logo</p></span>
                                  <input type="file" id="uploadLogo` + t.elemIds + `" class="uploadCollegeImg uploadImgs facultyImg" onchange="changeRacLogo(event)"/>
                                  <label for="uploadLogo` + t.elemIds + `"><div class="editIcon"><i class="fas fa-pencil-alt"></i></div></label></div></div>
                                  <div class="col-md-3 border-right"><input type="text" id="" name="" placeholder="Recruiter" class="info-input"/></div>
                                  <div class="col-md-3 border-right"><input type="text" id="" name="" placeholder="No. Of Recruitments" class="info-input"/>
                                  </div><div class="col-md-3"><input type="text" id="" name="" placeholder="Package Offered" class="info-input"/></div>`
      t.elemIds++;
      return recTemplate;
    },
    openCity(evt, moduleName) {
      var i, tabcontent, tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(moduleName).style.display = "block";
      evt.currentTarget.className += " active";
    },
    showImgName(event) {
      let imgPath = event.currentTarget;
      let filePath = imgPath.value;
      let imgPathParent = imgPath.parentElement;
      let fileName = imgPathParent.querySelector('.fileName');
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (!allowedExtensions.exec(filePath)) {
        alert('Invalid file type');
        imgPath.value = '';
        return false;
      } else {
        fileName.innerHTML = filePath;
      }
    },
    changeRacLogo(event) {
      let clickedElem = event.currentTarget;
      let imgPathUrl = event.currentTarget.value;
      let imgPath = URL.createObjectURL(event.target.files[0]);
      let parentElem = clickedElem.parentElement;
      let rootElem = parentElem.parentElement;
      let showenImg = rootElem.querySelector('.logoshow');
      console.log(showenImg);
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      if (!allowedExtensions.exec(imgPathUrl)) {
        alert('Invalid file type');
        return false;
      } else {
        showenImg.innerHTML = "<img src=" + imgPath + " class='w100'>";
        showenImg.querySelector('.w100').style.width = 100 + "%";
      }
    },
    addMoreRec(event) {
      let clickElem = event.currentTarget;
      let parentElem = clickElem.parentElement;
      let rootElem = parentElem.parentElement;
      let parentLi = rootElem.parentElement;
      console.log(parentLi);
      let div = document.createElement('div');
      div.setAttribute('class', 'row rowFlex mtb15');
      div.innerHTML = this.recTemp();
      console.log(parentLi.lastChild);
      parentLi.insertBefore(div, parentLi.lastChild);
    },
    streamModal(w){
      if(w){
        $('#streamModal').css({"display": "block"});
      }
    },
    courseModal(w, e = null) {
      if (w) {
        $('#courseModal').css({"display": "block"});
        this.$refs.cModal.anotherModal();
      } else {
        var el = e.currentTarget;
        var data_key = el.getAttribute('data-key');
        this.$refs.cModal.anotherModal(data_key);
      }
    },
    update() {
      var t = this;
      var url = t.$store.getters.getDomain;
      t.website_error = '';
      t.city_error = '';
      t.affiliated_to_error = '';

      var flag = 0;
        if (t.college_city == '') {
        t.city_error = "This field can't be empty";
        flag = 1;
      }
      if (t.college_website == '') {
        t.website_error = "This field can't be empty";
        flag = 1;
      }
      if (t.college_affiliated_to == '') {
        t.affiliated_to_error = "This field can't be empty";
        flag = 1;
      }
      if (flag === 1) {
        return false;
      }

        var data = {
            'description': t.college_description,
            'location': t.college_city,
            'university': t.college_affiliated_to,
            'website': t.college_website,
            'org_enc_id': t.college_enc_id,
        };

      showLoader();
      // request to update basic info
      axios.post(`${url}api/v2/college-profile/save-detail`, data, {headers: requestHeaders()}).then(function (response) {
        hideLoader();
      });

    },
    removeStream(event){
      var result = confirm("Are You Sure Want to Remove!");
      if(result == true){
        var t = this;
        showLoader();
        var element = event.currentTarget;
        var data_key = element.getAttribute('data-key');
        var url = t.$store.getters.getDomain;

        axios.post(`${url}api/v2/college-profile/remove-stream`, {course_enc_id:data_key}, {headers: requestHeaders()})
            .then(function (response){
              if(response['data']['response']['status'] == 200){
                toastr.success('Stream Successfully Removed', 'Removed');
                t.streams = response['data']['response']['streams'];
              }else {
                toastr.error('Some error occurred. Try again later', 'Oops!!');
              }
              hideLoader();
            })
      }
    },
    removeCourse(event){
      var result = confirm("Are You Sure Want to Remove!");
      if (result == true) {
        var t = this;
        showLoader();
        var element = event.currentTarget;
        var data_key = element.getAttribute('data-key');
        var url = t.$store.getters.getDomain;

        axios.post(`${url}api/v2/college-profile/remove-course`, {course_enc_id:data_key}, {headers: requestHeaders()}).then(function (response) {
          if (response['data']['response']['status'] == 200) {
            toastr.success('Course Successfully Removed', 'Removed');
            t.coursesList = response['data']['response']['courses'];
            t.$store.dispatch("setCourses", t.coursesList);
          } else {
            toastr.error('Some error occurred. Try again later', 'Oops!!');
          }
          hideLoader();
        });
      }
    },
    changePassword()  {
      var t = this;
      var url = t.$store.getters.getDomain;

      if(!t.validateForm()){
        return false;
      }
      var elements = document.getElementById('changePassForm').elements;
      var obj = {};
      for (var i = 0; i < elements.length; i++) {
        var item = elements.item(i);
        if (item.name != "") {
          obj[item.name] = item.value;
        }
      }
      showLoader();
      //request to update basic info
      axios.post(`${url}api/v2/auth/change-password`, obj, {headers: requestHeaders()}).then(function (response) {
        hideLoader();
        if (response['data']['response']['status'] == 200) {
          toastr.success('Password changed successfully', 'Success');
          for (var i = 0; i < elements.length; i++) {
            var item = elements.item(i);
            item.value = "";
          }
        } else if (response['data']['response']['status'] == 403) {
          toastr.error('The old password did not match. Please Try again', 'Oops!!');
        } else if (response['data']['response']['status'] == 409) {
          toastr.error(response['data']['response'][0].new_password[0], 'Oops!!');
        } else {
          toastr.error('Some error occurred. Try again later', 'Oops!!');
        }
      });
    },
    validateForm: function () {
      var x, y, z, i, valid = true, a = this;
      x = document.getElementById("changePassForm");
      y = x.getElementsByTagName("input");
      for (i = 0; i < y.length; i++) {
        if (y[i].value == "") {
          y[i].className += " invalid";
          valid = false;
        } else {
          y[i].classList.remove('invalid');
        }
      }
      if (document.getElementById('new-password').value != document.getElementById('confirm-password').value) {
        document.getElementById('new-password').className += " invalid";
        document.getElementById('confirm-password').className += " invalid";
        valid = false;
      }

      if (document.getElementById('new-password').value.length < 8) {
        alert('Password must have 8 characters. Use small letters with combination of Capitals and numbers with special symbols like @*.')
        document.getElementById('new-password').className += " invalid";
        valid = false;
      }
      return valid;
    },
    htmlDecoder(str) {
      var textArea = document.createElement('textarea');
      textArea.innerHTML = str;
      return textArea.value;
    }
  }
}
</script>
<style>
.mt30{
  margin-top: 30px;
}
.tab-container ul li{
  list-style: none;
}
.p10-20{
    padding: 10px 20px
}
.grid-container {
  display: grid;
  grid-gap: 15px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.eventNone{
  pointer-events: none;
}
.mr10{
  margin-left: 10px;
}
.formLabel{
  font-weight: bold !important;
  font-size: 13px;
  margin-bottom: 2px !important;
}
.cp_cancelBtn{
  margin-left: 5px;
}
.actionBtns{
  position: absolute;
  bottom: 5px;
  right: 10px;
}
.removeSch{
  background: transparent;
  padding: 0px;
  color: #df4759;
  border:none;
  font-family: roboto;
  font-size: 14px;
}
.deleteBtn:hover{
  color: #df4759;
}
.removeSch:hover{
  color:#ee152e;
  transition: .3s ease;
}
.editBtn{
  color: #00a0e3;
  border-right: 1px solid #eee;
  padding-right: 5px;
  margin-right: 5px;
}
.editBtn:hover{
  color: #ff7803;
  transition: .3s ease;
}
.showEdit {
  display: none;
}
.create-faculty .showEdit {
  display: block;
}

.showFiled {
  display: block;
}

.addMoretr {
  background: transparent;
  border: none;
  color: #000;
  margin-top: 10px;
}

.addMoretr:hover {
  color: #00a0e3;
}

.mt10 {
  margin-top: 20px;
}

.facInput {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: none;
}

.facInput-show {
  display: block;
}

.tb-form {
  display: flex;
  position: relative;
  margin: 10px 0;
}

.cutOff-list li {
  display: inline;
  padding-right: 20px;
}

.cutOff-list li span {
  font-weight: 600;
}

.college-details {
  padding-bottom: 0px !important;
}

.course-name a {
  display: flex;
}

.formInfo form {
  text-align: right;
}

.course-name i {
  margin-left: 5px;
}

.ct-course p {
  font-size: 12px
}

.teacher-box p, .teacher-box h4 {
  position: relative;
}

.faculty-Img, .topRecLogo {
  width: 70px;
  height: 70px;
  border: 1px solid #eee;
  padding: 3px;
  margin-bottom: 10px;
  position: relative;
}

.topRecLogo {
  margin: 0 auto;
}

.topRecLogo span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.topRecLogo span p {
  margin-bottom: 0px;
}

.faculty-Img img,
.topRecLogo span img,
.w100 {
  width: 100%;
  height: 100%;
}

.editIcon {
  position: absolute;
  right: -10px;
  top: -10px;
  background: #00a0e3;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 12px;
  border-radius: 5px;
}

.editDetails {
  color: #333;
  display: inline-block;
  font-size: 12px;
  margin-left: 10px;
  cursor: pointer;
}

.cpe-button {
  background: #00a0e3;
  padding: 8px 15px;
  color: #fff;
  border-radius: 10px 0px 10px 0;
  font-size: 13px;
  display: inline-block;
  border: none;
}

.cross {
  position: absolute;
  font-size: 23px;
  left: 10px;
  z-index: 9;
  cursor: pointer;
}

.cross:hover {
  color: #00a0e3;
}

.posRel {
  position: relative;
  padding: 5px 20px;
}

.admission-form, .cutOff-form {
  height: calc(100vh - 190px);
  overflow: hidden;
  position: relative;
}

#updateCourseData label {
  text-align: left;
  display: block;
  font-weight: 600 !important;
  font-size: 13px;
}

.cutOff-form {
  height: auto;
}

.admission-sidebar {
  position: fixed;
  width: 40vw;
  top: 100px;
  right: 0;
  height: calc(100vh - 100px);
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, .1);
  text-align: center;
  padding: 10px 0px;
  transition: .3s ease;
}

.admission-sidebar.ps-container .ps-scrollbar-x {
  display: none !important;
}

.admission-sidebar-close {
  width: 0;
  overflow: hidden;
  transition: .3s ease;
}

.album-img {
  height: 200px;
  margin-bottom: 15px;
}

.album-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.album {
  box-shadow: 0 0 10px rgba(0, 0, 0, .1);
  padding: 10px 15px;
  margin-bottom: 30px;
}

.album-header {
  padding: 0px 0px 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.album-header h4 {
  color: #00a0e3;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
}

.up-label,
.up-label-2 {
  display: flex;
}

.up-label p,
.up-label-2 p {
  margin-left: 10px;
  color: #333;
}

.uploadImgBtn,
.uploadImgBtn2,
.uploadImgBtn3 {
  position: relative;
  padding: 10px;
}

.uploadCollegeImg {
  visibility: hidden;
}

.uploadImgBtn label,
.uploadImgBtn2 label,
.uploadImgBtn3 label {
  position: absolute;
  top: 0;
  color: #00a0e3;
  font-size: 18px;
  padding: 10px;
}

.uploadImgBtn2 label {
  padding: 0;
  right: 0;
}

.uploadImgBtn3 label {
  left: 0;
  padding: 0;
}

.uploadImgBtn3 p {
  margin-top: 20px;
}

.uploadImgBtn label i {
  margin-right: 10px;
}

.openEditSide {
  color: #888;
  font-size: 13px;
  cursor: pointer;
}

.up-label-2 {
  background: #00a0e3;
  color: #fff;
  padding: 8px 10px;
}

.facultyImg {
  display: inline-block !important;
}

.tab-container textarea {
  padding: 10px;
}

.fIcon {
  width: 25%;
  text-align: center;
  justify-content: center;
}

.fIcon i {
  color: #00a0e3;
  font-size: 50px;
}

.co-flex {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 5px;
}

.co-flex label {
  margin-right: 10px;
  font-size: 16px;
  font-weight: bold;
  width: 100px;
  text-align: center;
}

.tb-btn {
  text-align: center;
}

.tb-btn button {
  background: #00a0e3;
  color: #fff;
  border: 1px solid #00a0e3;
  padding: 13px 8px;
  border-radius: 5px;
  line-height: 0;
}

.teacher-box {
  padding: 10px;
  border: 1px solid #eee;
  border-bottom: 5px solid #00a0e3;
  position: relative;
  margin-bottom: 20px;
  position: relative;
}
.removeFac{
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px 10px;
  background: #00a0e3;
  color: #fff;
}
.teacher-box h4 {
  font-size: 18px;
  color: #00a0e3;
  margin-bottom: 10px !important;
}

.teacher-box p {
  margin-bottom: 5px;
}

.mb2 {
  margin-bottom: 20px;
}
.mb-15{
  margin-bottom: 15px;
}
.addFee span {
  font-weight: bold;
}

.admi-card-body h5 {
  font-size: 16px;
  font-weight: bold;
}

.info-text {
  min-height: 450px;
  width: 100%;
  border: 1px solid #eee;
  padding: 10px 15px;
  line-height: 22px;
}

.scholar-form textarea {
  min-height: 400px;
  width: 100%;
  padding: 10px !important;
  line-height: 20px;
  text-align: justify;
  text-indent: 0;
}

#infraDetails {
  min-height: 300px;

}

.admission-form .add-s-textarea {
  height: 125px;
}

.admission-form .add-d-textarea {
  height: 350px;
}

.form-heading {
  font-size: 18px;
  margin-top: 0;
}

.info-table {
  margin-bottom: 30px;
}

.info-table ul li {
  border: 1px solid #eee;
  padding: 15px 15px;
}

.info-table ul li:nth-child(even) {
  background: #f7f7f7;
}

.border-right {
  border-right: 1px solid #eee;
  text-align: center;
  line-height: 18px;
}

.info-input {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  text-indent: 10px;
  border: none;
  box-shadow: 0 0 2px rgba(0, 0, 0, .1);
}

.formTextFields {
  width: 100%;
  padding: 10px 0;
  text-indent: 15px;
  border: 1px solid #eee;
  margin-bottom: 15px;
  min-height: 40px;
}

.info-text:focus,
.formTextFields:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(0, 0, 0, .1);
}

.facultyForm .formTextFields {
  margin-bottom: 0px;
}

.create-fac .facultyForm .formTextFields {
  margin-bottom: 10px;
}

.formShadow {
  box-shadow: 0 4px 8px rgba(0, 0, 0, .1);
  padding: 10px 15px;
  margin-bottom: 30px;
}

.formBorder {
  border-right: 1px solid #eee;
  padding: 10px 15px;
}

.rowFlex {
  display: flex;
  align-items: center;
}

.cp-edit {
  width: 100vw;
}

.cp-menu {
  width: 15vw;
  border-right: 1px solid #eee;
  height: 100vh;
  position: fixed;
}

.cp-menu p {
  font-size: 18px;
  padding: 15px;
  background: #eee;
  margin-bottom: 0;

}

.cp-menu ul li {
  border-bottom: 1px solid #eee;
  font-size: 17px;
}

.cp-menu ul li a {
  padding: 15px 15px;
  color: #333;
  display: inline-block;
  width: 100%;
}


/* Change background color of buttons on hover */
.cp-menu ul li a:hover {
  background-color: #eee;
}

/* Create an active/current "tab button" class */
.cp-menu ul li a.active {
  padding: 15px 15px;
  color: #fff;
  display: inline-block;
  width: 100%;
  background-color: #00a0e3;
}

/* Style the tab content */
.tabcontent {
  padding: 0px 12px;
  margin: 0 30px 0 15px;
}

.tab-container {
  margin-left: 15vw;
}

table.courseTable {
  width: 100%;
  border-collapse: collapse;
}

/* Zebra striping */
.courseTable tr:nth-of-type(odd) {
  background: #f7f7f7;
}

.courseTable th {
  background: #00a0e3;
  color: #fff;
  font-weight: 500;
  text-align: center;
}

.courseTable td,
.courseTable th {
  padding: 10px;
  border: 1px solid #f2f2f2;
  font-size: 15px;

}

.ct-eligi,
.ct-scholarship,
.ct-course {
  width: 20%;
}

.ct-stream,
.ct-fee {
  width: 15%;
}

.ct-duration, .ct-edit {
  width: 5%;
}

.card-header {
  padding: 0px;
}

.card-header a {
  width: 100%;
  padding: 10px 1.25rem;
}

.card-header a h5 {
  width: 100%;
}

.card-header i {
  float: right;
}

.card-body {
  padding: 10px 15px 20px 15px;
  line-height: 23px;
  font-size: 16px;
  text-align: justify;
}

.cutoff.card-body {
  text-align: left;
}

.infraCheck {
  margin-top: 15px;
}

.infraCheck input[type="checkbox"] {
  position: absolute;
  visibility: hidden;
}

.infraCheck input[type="checkbox"]:not(:disabled) ~ label {
  cursor: pointer;
}

.infraCheck input[type="checkbox"]:disabled ~ label {
  color: #bcc2bf;
  border-color: #bcc2bf;
  box-shadow: none;
  cursor: not-allowed;
}

.infraCheck label {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 2px solid #eee;
  border-radius: 20px;
  padding: 10px 10px 0px 10px;
  margin-bottom: 1rem;
  text-align: center;
  box-shadow: 0px 3px 10px -2px rgba(161, 170, 166, 0.5);
  position: relative;
  color: #00a0e3;
  min-height: 125px;
}

.infraIcon {
  width: 50px;
  height: 40px;
  display: flex;
  align-items: flex-end;
}

.infraCheck label img {
  width: 100%;
}

.infraCheck label i {
  font-size: 50px;
  padding-top: 20px;
}

.infraCheck label h3 {
  margin-top: 7px;
  font-size: 16px !important;
  text-transform: capitalize;
  line-height: 20px;
  margin-bottom: 0;
}

.infraCheck input[type="checkbox"]:checked + label {
  background: #00a0e3;
  color: white;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
}

.infraCheck input[type="checkbox"]:checked + label::after {
  color: #3d3f43;
  font-family: "Font Awesome 5 Free";
  border: 2px solid #00a0e3;
  font-weight: 900;
  content: "\f00c";
  font-size: 16px;
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  height: 30px;
  width: 30px;
  line-height: 28px;
  text-align: center;
  border-radius: 50%;
  background: white;
  box-shadow: 0px 2px 5px -2px rgba(0, 0, 0, 0.25);
}

@media only screen and (max-width: 760px),
(min-device-width: 768px) and (max-device-width: 1024px) {

  /* Force table to not be like tables anymore */
  table.courseTable ,
  .courseTable thead,
  .courseTable tbody,
  .courseTable th,
  .courseTable td,
  .courseTable tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .courseTable thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .courseTable tr {
    border: 1px solid #ccc;
  }

  .courseTable td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;

  }

  .courseTable td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /*
  Label the data
  */
  #course table td:nth-of-type(1):before {
    content: "First Name";
  }

  #course table td:nth-of-type(2):before {
    content: "Last Name";
  }

  #course table td:nth-of-type(3):before {
    content: "Job Title";
  }

  #course table td:nth-of-type(4):before {
    content: "Favorite Color";
  }

}
.editCourse {
  color: #00a0e3;
  cursor: pointer;
  background: transparent;
  padding: 0;
  border: none;
}

.saveInfraBtn {
  position: absolute;
  bottom: -24px;
  right: 0px;
  background: #00a0e3;
  color: #fff;
  border: 1px solid #00a0e3;
  padding: 3px 12px;
  border-radius: 0 0 5px 5px;
  z-index: 1;
}

.charcount {
  position: absolute;
  bottom: -20px;
  left: 23%;
  display: inline-flex;
  margin: 0;
  color: #999;
  font-family: roboto;

}

.charcount span {
  padding-left: 5px
}

.XRail {
  display: none !important;
}

.mb1 {
  margin-bottom: 10px;
}

.mt-0 {
  margin-top: 0px;
}

.errorMsg {
  display: none;
  font-size: 12px;
  color: #df4759;
  margin-top: -12px;
}
#cutOffForm .errorMsg,
#addCourse .errorMsg,
#coursePlacement .errorMsg,
.co-flex .errorMsg {
  position: absolute;
  bottom: -10px;
  left: 100px;
}

#cutOffForm .errorMsg,
#addCourse .errorMsg,
#coursePlacement .errorMsg{
  left: 15px
}

#cutOffForm .errorMsg,
#coursePlacement .errorMsg{
  bottom: -13px;
  margin-bottom: 0px;
}

.info-input {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  text-indent: 10px;
  border: none;
  box-shadow: 0 0 2px rgba(0, 0, 0, .1);
}

.border-right {
  border-right: 1px solid #eee;
  text-align: center;
  line-height: 18px;
}

.facility-box {
  display: flex;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, .1);
  padding: 0px 0px;
  width: 100%;
  margin-bottom: 45px;
  position: relative;
}

.facility-box textarea {
  height: 150px;
  margin-bottom: 0;
  border: none;
  border-left: 1px solid #eee;
  padding: 10px;
  text-align: justify;
  line-height: 20px;
}

.fIcon {
  width: 30%;
  text-align: center;
  justify-content: center;
}

.fIcon i {
  color: #00a0e3;
  font-size: 50px;
}

.fIcon p {
  text-align: center !important;
  width: 100% !important;
  margin: 10px 0 0 0;
  font-size: 16px;
  text-transform: capitalize;
}

.facility-box p {
  width: 75%;
  text-align: justify;
  line-height: 20px;
  padding: 0 5px;
}

.formTextFields {
  width: 100%;
  padding: 10px 0;
  text-indent: 15px;
  border: 1px solid #eee;
  margin-bottom: 10px;
}

.info-text:focus,
.formTextFields:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(0, 0, 0, .1);
}

.rowFlex {
  display: flex;
  align-items: center;
}

.mtb15 {
  margin-bottom: 15px;
  margin-top: 15px;
}

.topRecLogo {
  width: 70px;
  height: 70px;
  border: 1px solid #eee;
  padding: 3px;
  margin-bottom: 10px;
  position: relative;
}

.topRecLogo {
  margin: 0 auto;
}

.topRecLogo span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.topRecLogo span p {
  margin-bottom: 0px;
}

.faculty-Img img,
.topRecLogo span img,
.w100 {
  width: 100%;
  height: 100%;
}

.facultyImg {
  display: inline-block !important;
}

.uploadCollegeImg {
  visibility: hidden;
}

.editIcon {
  position: absolute;
  right: -10px;
  top: -10px;
  background: #00a0e3;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 12px;
  border-radius: 5px;
}
.modal-contents {
  overflow: hidden !important;
  position: relative;
  background-color: #fff;
  overflow-y: scroll !important;
}

.modal-heading {
  text-align: center;
  padding: 10px;
}

</style>
<style src="croppie/croppie.css"></style>